import { render, staticRenderFns } from "./veStuGraduationByzbhRuleShow.vue?vue&type=template&id=381f0ada&scoped=true"
import script from "./veStuGraduationByzbhRuleShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationByzbhRuleShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f0ada",
  null
  
)

export default component.exports